import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AstroBaseMapKey } from "../../../../models/interfaces";
import astrocartographyStyles from "../Astrocartography.styles";
import { BASE_MAPS } from "../utils/astrocartographyConstants";

interface AstroBaseMapControlProps {
  baseMapKey: AstroBaseMapKey;
  onChange: (key: AstroBaseMapKey) => void;
}

/** Preview fills standing in for each tile style, so the choice is seen not read. */
const PREVIEWS: Record<string, string> = {
  colour:
    "linear-gradient(150deg, #A8D5A2 0%, #E8DFA8 42%, #7FB8D9 78%, #4A90C2 100%)",
  light:
    "linear-gradient(150deg, #FBFBFB 0%, #ECEFF3 45%, #DCE3EA 75%, #C9D3DD 100%)",
  dark: "linear-gradient(150deg, #2A2F3A 0%, #1B1F27 45%, #12151B 78%, #0A0C10 100%)",
  sat: "linear-gradient(150deg, #2F5D3A 0%, #6B5A32 38%, #1B3A5C 72%, #0C1B2E 100%)",
};

const AstroBaseMapControl = (props: AstroBaseMapControlProps) => {
  const classes = astrocartographyStyles;
  const { t } = useTranslation();
  const { baseMapKey, onChange } = props;

  return (
    <ToggleButtonGroup
      exclusive
      value={baseMapKey}
      onChange={(event, value) => value && onChange(value)}
      sx={classes.baseMapGroup}
    >
      {BASE_MAPS.map((base) => (
        <ToggleButton key={base.key} value={base.key}>
          <Box sx={classes.baseMapPreview(PREVIEWS[base.key])} />
          {base.key === baseMapKey && (
            <Box sx={classes.baseMapCheck}>
              <CheckRoundedIcon />
            </Box>
          )}
          <Typography component="span" sx={classes.baseMapLabel}>
            {t(base.labelKey)}
          </Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default AstroBaseMapControl;
